import { isLoggedIn } from "@/core/auth/token";
import { synchronizeUserPermission } from "@/core/auth/synchronizeUserPermission";
import { isSsoLoginStrategy } from "@/core/loginStrategy";
import { goLogin } from "@/core/navigation";

const WHITELIST = new Set(["/", "/login", "/test"]);

function isWhitelisted(to) {
  if (WHITELIST.has(to.path)) {
    return true;
  }
  return to.path.startsWith("/demo/markdown");
}

export function setupAuthGuard(router, store) {
  router.beforeEach(async (to, _from, next) => {
    const loggedIn = isLoggedIn();

    if (isWhitelisted(to)) {
      if (loggedIn) {
        await synchronizeUserPermission(store);
        await store.dispatch("permission/fetchPermission");
      }
      return next();
    }

    if (!loggedIn) {
      if (isSsoLoginStrategy()) {
        goLogin(to.fullPath);
        return next(false);
      }
      return next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    }

    await synchronizeUserPermission(store);

    if (!store.state.auth.loginReady) {
      await store.dispatch("auth/restoreSession");
    }

    if (!store.state.auth.localUser) {
      return next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    }

    await store.dispatch("permission/fetchPermission");

    if (to.path.startsWith("/admin") && !store.state.auth.isAdmin) {
      return next("/search");
    }

    next();
  });
}
